import React, { useState } from "react";
import AccountsList from "../../pages/AccountsList";
import AddAccountContainer from "../../pages/AddAccountContainer";
import { Plus, List } from "lucide-react";

export default function MobileAccounts() {
  const [view, setView] = useState("list"); // 'list' or 'add'

  return (
    <div style={styles.container}>
      {/* 1. PROFESSIONAL TOGGLE SWITCH */}
      <div style={styles.toggleContainer}>
        <button 
          onClick={() => setView("list")} 
          style={{
            ...styles.toggleBtn, 
            background: view === "list" ? "#1e293b" : "transparent", 
            color: view === "list" ? "#38bdf8" : "#64748b"
          }}
        >
          <List size={16} />
          <span>My Portfolio</span>
        </button>
        <button 
          onClick={() => setView("add")} 
          style={{
            ...styles.toggleBtn, 
            background: view === "add" ? "#1e293b" : "transparent", 
            color: view === "add" ? "#38bdf8" : "#64748b"
          }}
        >
          <Plus size={16} />
          <span>Add New</span>
        </button>
      </div>

      {/* 2. SHARED MOBILE STYLES (Overrides Web Components) */}
      <style>{`
        /* PREVENT GLOBAL OVERFLOW */
        .mobile-account-wrapper {
          width: 100%;
          overflow-x: hidden;
          box-sizing: border-box;
        }

        /* FIX 1: SUMMARY BAR STACKING */
        .mobile-account-wrapper [style*="summaryContainer"], 
        .mobile-account-wrapper [style*="portfolioBar"], 
        .mobile-account-wrapper [style*="phaseBar"] {
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 15px !important;
          padding: 20px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        /* FIX 2: ACCOUNT SELECTION CARDS (AddAccountSelector.js) */
        .mobile-account-wrapper [style*="cardGrid"] {
          display: flex !important;
          flex-direction: column !important;
          gap: 16px !important;
          padding: 0 20px !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .mobile-account-wrapper [style*="cardGrid"] > div {
          min-width: 0 !important; /* Removes web 300px restriction */
          width: 100% !important;
          padding: 20px !important; /* Reduces large web padding */
          box-sizing: border-box !important;
        }

        /* FIX 3: FORM ROW STACKING (AddAccount.js & AddPersonalAccount.js) */
        .mobile-account-wrapper [style*="display: flex"][style*="gap: 16px"],
        .mobile-account-wrapper [style*="row"] {
          flex-direction: column !important;
          width: 100% !important;
          gap: 18px !important;
        }

        /* FIX 4: INPUT & CARD BOX SIZING */
        .mobile-account-wrapper input, 
        .mobile-account-wrapper select,
        .mobile-account-wrapper [style*="card"],
        .mobile-account-wrapper [style*="selectionCard"] {
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }

        /* FIX 5: REDUCE WEB PADDING FOR MOBILE FORMS */
        .mobile-account-wrapper [style*="padding: 30px"],
        .mobile-account-wrapper [style*="padding: 24px"] {
          padding: 20px !important;
        }

        /* FIX 6: PORTFOLIO LIST GRID */
        .mobile-account-wrapper [style*="cardsGrid"] {
          grid-template-columns: 1fr !important;
          gap: 12px !important;
          padding: 0 10px !important;
        }

        /* CLEAN UP ACCORDION HEADERS */
        .mobile-account-wrapper [style*="accordionHeader"] {
          padding: 16px 15px !important;
        }
      `}</style>

      {/* 3. RENDER CONTENT */}
      <div className="mobile-account-wrapper">
        {view === "list" ? <AccountsList /> : <AddAccountContainer />}
      </div>
    </div>
  );
}

const styles = {
  container: { 
    width: "100%", 
    paddingBottom: "120px", /* Extra space for floating footer */
    boxSizing: "border-box"
  },
  toggleContainer: {
    display: "flex",
    background: "rgba(15, 23, 42, 0.5)",
    borderRadius: "12px",
    padding: "4px",
    margin: "0 20px 20px 20px",
    border: "1px solid #1e293b"
  },
  toggleBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    border: "none",
    padding: "10px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    transition: "0.2s ease",
    cursor: "pointer",
    outline: "none"
  }
};